import { render, staticRenderFns } from "./ClonacionForm.vue?vue&type=template&id=67fa9b56&"
import script from "./ClonacionForm.vue?vue&type=script&lang=js&"
export * from "./ClonacionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports